export const ACCESS_TOKEN = "avengers.access_token";
export const REFRESH_TOKEN = "avengers.refresh_token";

export const MY_DEPOSIT_ACCESS_TOKEN = "mydAccessToken";
export const MY_DEPOSIT_REFRESH_TOKEN = "mydRefreshToken";

export const REFRESH_TOKEN_RETRY_COUNT = 3;
export const REFRESH_TOKEN_RETRY_DELAY = 500;
